import { useEffect, useLayoutEffect, useState } from 'react';
import {
  Box,
  Button,
  Card,
  Chip,
  FormControl,
  FormLabel,
  IconButton,
  MenuItem,
  Stack,
  Tab,
  TextField,
  Tooltip,
  Typography,
  styled,
  useMediaQuery,
} from '@mui/material';
import { TabContext, TabList } from '@mui/lab';
import {
  useGetFeatureModulesQuery,
  useGetUserPermissionsQuery,
  useRevokeUserPermissionsMutation,
  useSetUserPermissionsMutation,
} from '../userApiSlice';
import FeaturePanel from './FeaturePanel';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectGrantButtonsDisabled,
  selectModules,
  selectRevokeButtonsDisabled,
  selectSelectedFeatures,
  selectSelectedUsers,
  selectSidebarOpen,
  setGrantButtonDisabled,
  setModules,
  setRevokeButtonDisabled,
  setSelectedFeatures,
} from '../userSlice';
import UserAvatar from '../../../common/UserAvatar';
import { variants } from '../../../variants/variants';
import { CheckCircleOutline, RemoveCircleOutline, Settings, SupervisedUserCircle } from '@mui/icons-material';
import SettingsTab from './SettingsTab';
import SettingsHeader from './SettingsHeader';
import Admin from '../../../assets/Admin.png';

const roles = ['EMPLOYEE', 'HR', 'RMG', 'MANAGER', 'CUSTOM'];

// const Roles = [
//   {
//     "department": "Executive Leadership",
//     "roles": {
//       "C-Suite Level": [
//         "Founder, Chairman & Group CEO",
//         "Group Chief Executive Officer",
//         "Group Chief Operating Officer",
//         "Chief Executive Officer (CEO)",
//         "Group CFO",
//         "Chief Growth Officer",
//         "Chief Human Resources Officer",
//         "CTO - Autofacets/AutoDAP/Dilx"
//       ],
//       "Business Unit Leadership": [
//         "CEO - Autofacets",
//         "CEO - Gateway Digital (& regional variants)",
//         "COO - Autofacets",
//         "Group Chief Executive - EMEA",
//         "Chief Strategy Officer - North America"
//       ]
//     }
//   },
//   {
//     "department": "Technology & Engineering",
//     "roles": {
//       "Executive Level": [
//         "Vice President - Technology",
//         "VP - Strategic Accounts"
//       ],
//       "Senior Management": [
//         "Delivery Head (& business unit variants)",
//         "Sr. Manager - Strategic Technology Consulting",
//         "Sr. Manager - IT Infra & Procurement"
//       ],
//       "Management": [
//         "Program/Project Manager",
//         "Manager - Strategic Technology Consulting",
//         "Manager - Support"
//       ],
//       "Technical Leadership": [
//         "Enterprise/Solution Architect",
//         "Sr. Lead - Architecture/Innovation/Software",
//         "Tech Lead/Lead - Architecture/Projects/Software"
//       ],
//       "Individual Contributors": [
//         "Sr. Engineer/Analyst - Software/Network/UI/UX",
//         "Engineer/Analyst - Software/Network/UI/UX",
//         "Business Analyst",
//         "Associate"
//       ]
//     }
//   },
//   {
//     "department": "Quality Assurance",
//     "roles": {
//       "All Levels": [
//         "Sr. Lead - QA",
//         "Lead - QA",
//         "Sr. Engineer - QA",
//         "Engineer - QA"
//       ]
//     }
//   },
//   {
//     "department": "Sales & Business Development",
//     "roles": {
//       "Executive Level": [
//         "VP - Sales (various regions)",
//         "VP & Client Success Manager"
//       ],
//       "Senior Management": [
//         "AVP Sales & Client Success Manager (various units/regions)",
//         "Client Success Director",
//         "Sr. Manager - Business Development"
//       ],
//       "Management": [
//         "Manager - Business Development/Sales",
//         "Team Lead - Business Development",
//         "Client Success Manager"
//       ]
//     }
//   },
//   {
//     "department": "Human Resources",
//     "roles": {
//       "Executive Level": [
//         "VP - Talent Acquisition & Operations"
//       ],
//       "Senior Management": [
//         "Sr. Manager - Talent Acquisition & Development/Human Resources"
//       ],
//       "Management": [
//         "Manager - Human Resources/Talent Acquisition/Payroll",
//         "Asst. Manager - Human Resource & Payroll/Talent Development"
//       ],
//       "Individual Contributors": [
//         "Sr. Executive/Executive - Human Resources/Talent Acquisition"
//       ]
//     }
//   },
//   {
//     "department": "Finance & Accounting",
//     "roles": {
//       "Executive Level": [
//         "VP - Global Accounts & Taxation",
//         "AVP - Finance/Accounts & Taxation"
//       ],
//       "Senior Management": [
//         "Sr. Manager - Finance/Accounts & Treasury"
//       ],
//       "Management": [
//         "Manager - Finance/Accounts & Banking/Taxation",
//         "Assistant Manager - Finance/MIS/Accounts"
//       ],
//       "Individual Contributors": [
//         "Executive – Accounts",
//         "Junior Accountant"
//       ]
//     }
//   },
//   {
//     "department": "Marketing & Communications",
//     "roles": {
//       "Senior Management": [
//         "Head - Marcom",
//         "Sr. Manager - Creative Services"
//       ],
//       "Management": [
//         "Manager - Marketing",
//         "Asst. Manager - Marketing/Business Branding & Content",
//         "Lead - Creative services"
//       ],
//       "Individual Contributors": [
//         "Sr. Graphic Designer/Graphic Designer",
//         "Motion Graphic Artist",
//         "Content Writer/Senior Content Writer",
//         "SEO Executive",
//         "Executive - Marcom/RMG"
//       ]
//     }
//   },
//   {
//     "department": "Legal & Compliance",
//     "roles": {
//       "Senior Management": [
//         "Head Legal",
//         "VP - Corporate Affairs & CEO AFP",
//         "AVP - Corporate Strategy & Legal"
//       ],
//       "Management": [
//         "Manager - Legal & Compliance",
//         "Asst. Manager - Legal & Compliance"
//       ],
//       "Individual Contributors": [
//         "Sr. Executive - Legal"
//       ]
//     }
//   },
//   {
//     "department": "Operations & Administration",
//     "roles": {
//       "Senior Management": [
//         "Director of Operations",
//         "Sr Manager - Operations",
//         "General Manager - Admin"
//       ],
//       "Management": [
//         "Manager - Travel desk",
//         "Asst Manager - Purchase & Admin/Security & Admin"
//       ],
//       "Individual Contributors": [
//         "Office Assistant/Sr. Office Assistant",
//         "Executive - Front Desk & Administrative Services",
//         "Support Staff (Driver, Electrician, Technician)"
//       ]
//     }
//   },
//   {
//     "department": "Specialized Departments",
//     "roles": {
//       "Security Solutions": [
//         "Sr. Analyst/Engineer - Security Solutions",
//         "Engineer - Security Solutions"
//       ],
//       "Managed Services": [
//         "VP – Managed Services",
//         "Lead - Managed Services",
//         "Sr. Analyst/Analyst - Managed Services",
//         "Engineer - Managed Services"
//       ],
//       "Research & Market Analysis": [
//         "Sr. Market Research Analyst",
//         "Market Research Analyst"
//       ],
//       "Mergers & Acquisitions": [
//         "Manager - M&A & Corporate Affairs",
//         "Executive - M&A",
//         "Associate - M&A & Corporate Affairs"
//       ]
//     }
//   }
// ]

const Roles = [
  {
    department: 'Executive Leadership',
    roles: {
      'C-Suite Level': [
        'Founder, Chairman & Group CEO',
        'Group Chief Operating Officer',
        'Chief Executive Officer',
        'Group CFO',
        'Chief Growth Officer',
        'Chief Human Resources Officer & Sr VP - Strategic Initiatives',
        'CTO - Autofacets',
        'CTO - AutoDAP',
        'CTO - Dilx',
      ],
      'Business Unit Leadership': [
        'CEO - Autofacets',
        'CEO - Gateway Digital',
        'CEO - Gateway Digital - UK',
        'COO - Autofacets',
        'Group Chief Executive - EMEA',
        'Chief Strategy Officer - North America',
        'Founder and Board Member - CEO AutoDAP and CEO GatewaySecure Labs',
        'Founder and Board Member - Group Chief Strategy Officer',
      ],
    },
  },
  {
    department: 'Technology & Engineering',
    roles: {
      'Executive Level': [
        'Vice President - Technology',
        'VP - Strategic Accounts - Autofacets',
        'VP - Strategic Accounts - Cross Media',
      ],
      'Senior Management': [
        'Delivery Head',
        'Delivery Head - Autofacets',
        'Delivery Head - Gateway Digital',
        'Sr. Manager - Strategic Technology Consulting - Autofacets',
        'Sr. Manager - Strategic Technology Consulting - Gateway Digital',
        'Sr. Manager - IT Infra & Procurement',
      ],
      'Management': [
        'Program Manager',
        'Project Manager',
        'Manager - Strategic Technology Consulting - Gateway Digital',
        'Manager - Support',
        'Assistant Manager - STC - AutoFacets',
        'Assistant Manager Support',
      ],
      'Technical Leadership': [
        'Enterprise Architect',
        'Solution Architect',
        'Architect',
        'Sr. Lead - Architecture',
        'Sr. Lead - Software Development',
        'Sr. Lead - Innovation and Research',
        'Lead - Architecture',
        'Lead - Software Development',
        'Lead - Projects',
        'Sr. Tech - Lead',
        'Tech Lead',
        'Head - SEPG (Software Engineering Process Group)',
      ],
      'Individual Contributors': [
        'Sr. Engineer - Software Development',
        'Sr. Engineer - Network & IT Infrastructure',
        'Sr. Engineer - UI/UX',
        'Sr. Engineer - UI/UX Design',
        'Sr. Analyst - Software Development',
        'Sr. Analyst Programmer',
        'Sr. Analyst - UI/UX',
        'Engineer - Software Development',
        'Engineer - Network & IT Infrastructure',
        'Engineer - UI/UX',
        'Analyst - Software Development',
        'Analyst - UI/UX',
        'Business Analyst',
        'Associate',
        'Sr. Executive - Strategic Technology Consulting',
        'Executive - Strategic Technology Consulting - AutoFacets',
        'Executive - Strategic Technology Consulting - Gateway Digital',
        'Executive - Strategic Technology Consulting – Dilx',
      ],
    },
  },
  {
    department: 'Quality Assurance',
    roles: {
      'All Levels': ['Sr. Lead - QA', 'Lead - QA', 'Sr. Engineer - QA', 'Engineer - QA'],
    },
  },
  {
    department: 'Sales & Business Development',
    roles: {
      'Executive Level': [
        'VP - Sales - Gateway Digital - Sweden',
        'VP - Sales - Gateway Digital - Finland',
        'VP & Client Success Manager - Gateway Digital',
      ],
      'Senior Management': [
        'AVP Sales & Client Success Manager - Gateway Digital',
        'AVP Sales & Client Success Manager - Autofacets',
        'AVP Sales - Gateway Digital - Norway',
        'AVP Sales & Client Success Manager - Gateway Digital - UK',
        'AVP - Business Development',
        'Client Success Director - Gateway Digital',
        'Sr. Manager - Business Development - Gateway Digital',
        'Sr. Manager - Business Development',
      ],
      'Management': [
        'Manager - Business Development',
        'Manager - Business Development - AutoFacets',
        'Manager - Sales - Gateway Digital',
        'Team Lead - Business Development',
        'Client Success Manager',
        'Asst. Manager - Sales - Gateway Digital',
      ],
      'Individual Contributors': [
        'Sr. Executive - Business Acquisition',
        'Executive - Marketing & Business Development',
      ],
    },
  },
  {
    department: 'Human Resources',
    roles: {
      'Executive Level': ['VP - Talent Acquisition & Operations'],
      'Senior Management': [
        'Sr. Manager - Talent Acquisition & Development',
        'Sr. Manager - Human Resources',
        'Senior Manager - Talent Acquisition',
      ],
      'Management': [
        'Manager - Human Resources',
        'Manager - Talent Acquisition & Development',
        'Asst. Manager - Human Resource & Payroll',
        'Assistant Manager - Talent Development',
        'Assistant Manager HR',
      ],
      'Individual Contributors': [
        'Sr. Executive - Talent Acquisition & Development',
        'Sr Executive - Human Resources',
        'Executive - Talent Acquisition & Development',
        'Executive - Talent Acquisition',
        'Executive - Human Resource',
        'Management Trainee',
      ],
    },
  },
  {
    department: 'Finance & Accounting',
    roles: {
      'Executive Level': [
        'VP - Global Accounts & Taxation',
        'AVP - Finance',
        'AVP - Finance & HR - EU',
        'AVP - Accounts & Taxation',
      ],
      'Senior Management': [
        'Sr. Manager - Finance - Autofacets & Diversified Business',
        'Sr. Manager - Accounts & Treasury',
      ],
      'Management': [
        'Manager - Finance',
        'Manager - Accounts & Taxation',
        'Manager - Accounts & Banking Compliance',
        'Manager - Payroll & Payables',
        'Assistant Manager MIS & Finance',
        'Assistant Manager Accounts',
        'Asst. Manager - Finance',
      ],
      'Individual Contributors': ['Executive – Accounts', 'Junior Accountant'],
    },
  },
  {
    department: 'Marketing & Communications',
    roles: {
      'Senior Management': [
        'Head - Marcom',
        'Head - Marketing & Business Development - North America',
        'Sr. Manager - Creative Services - Marcom',
        'Director - Business Acquisition and Marketing',
      ],
      'Management': [
        'Manager - Marketing',
        'Asst. Manager - Marketing',
        'Assistant Manager - Business Branding & Content - Marcom',
        'Lead - Creative services',
      ],
      'Individual Contributors': [
        'Sr. Graphic Designer - Marcom',
        'Sr. Graphic Designer',
        'Graphic Designer',
        'Graphic Designer and Social Media Strategist',
        'Motion Graphic Artist',
        'Senior Content Writer',
        'Content Writer',
        'SEO Executive',
        'Executive - Marcom',
        'Executive - RMG',
      ],
    },
  },
  {
    department: 'Legal & Compliance',
    roles: {
      'Senior Management': [
        'Head Legal',
        'Sr. VP - Corporate Affairs & CEO AFP',
        'VP Corporate Affairs',
        'AVP - Corporate Strategy & Legal',
      ],
      'Management': [
        'Manager - M&A & Corporate Affairs',
        'CS & Manager - Legal & Compliance',
        'Asst. Manager - Legal',
        'Asst. Manager - Legal & Compliance',
      ],
      'Individual Contributors': ['Sr. Executive - Legal'],
    },
  },
  {
    department: 'Operations & Administration',
    roles: {
      'Senior Management': ['Director of Operations', 'Sr Manager - Operations', 'General Manager - Admin'],
      'Management': [
        'Manager - Travel desk',
        'Asst Manager - Purchase & Admin Operations',
        'Asst. Manager - Security & Admin',
      ],
      'Individual Contributors': [
        'Sr. Office Assistant',
        'Office Assistant',
        'Executive - Front Desk & Administrative Services',
        'Executive Assistant',
        'Technician',
        'Driver',
        'Electrician',
        'Liasoning Associate',
      ],
    },
  },
  {
    department: 'Specialized Departments',
    roles: {
      'Security Solutions': [
        'Sr. Analyst - Security Solutions',
        'Sr. Engineer - Security Solutions',
        'Engineer - Security Solutions',
      ],
      'Managed Services': [
        'VP – Managed Services',
        'Lead - Managed Services',
        'Manager - Managed Services',
        'Sr. Analyst - Managed Services',
        'Analyst - Managed Services',
        'Engineer - Managed Services',
      ],
      'Research & Market Analysis': [
        'Sr. Market Research Analyst',
        'Market Research Analyst',
        'Market Reseach Analyst',
      ],
      'Mergers & Acquisitions': ['Executive - M&A', 'Associate - M&A & Corporate Affairs'],
      'Consultants': ['Consultant - Full Time', 'Consultant'],
    },
  },
];

const PermissionManager = () => {
  const [module, setModule] = useState('1');
  const [role, setRole] = useState('');
  const [settingsOpen, setSettingsOpen] = useState(false);
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('lg'));
  const dispatch = useDispatch();
  const { data: modulesData } = useGetFeatureModulesQuery();
  const modules = useSelector(selectModules);
  const selectedUsers = useSelector(selectSelectedUsers);
  const selectedPermissions = useSelector(selectSelectedFeatures);
  const grantDisabled = Boolean(selectedUsers.length === 0);
  const [grantPermission] = useSetUserPermissionsMutation();
  const [revokePermission] = useRevokeUserPermissionsMutation();

  const [selectedDepartment, setSelectedDepartment] = useState('');
  const [selectedRoleCategory, setSelectedRoleCategory] = useState('');
  const sideBar = useSelector(selectSidebarOpen)
  // const { data: candidatePermissionsData } = useGetUserPermissionsQuery('EMPLOYEE');
  // const { data: hrPermissionsData } = useGetUserPermissionsQuery('HR');
  // const { data: rmgPermissionsData } = useGetUserPermissionsQuery('RMG');
  // const { data: managerPermissionsData } = useGetUserPermissionsQuery('MANAGER');

  const {data: rolePermissionsData} = useGetUserPermissionsQuery(role)
  const grantButtonDisabled = useSelector(selectGrantButtonsDisabled)
  const revokeButtonDisabled = useSelector(selectRevokeButtonsDisabled)

  useLayoutEffect(() => {
    if (modulesData) {
      dispatch(setModules(modulesData.data));
    }
    dispatch(setSelectedFeatures({ signal: true }));
  }, [modulesData, dispatch]);

  useEffect(()=>{
    setSelectedDepartment('')
    setSelectedRoleCategory('')
    setRole('')
    setSettingsOpen(false)
  },[sideBar])

  useEffect(() => {
    let defaultPermissions = [];
    // switch (role) {
      // case 'EMPLOYEE':
      //   defaultPermissions = candidatePermissionsData?.data?.permissions || [];
      //   break;
      // case 'HR':
      //   defaultPermissions = hrPermissionsData?.data?.permissions || [];
      //   break;
      // case 'RMG':
      //   defaultPermissions = rmgPermissionsData?.data?.permissions || [];
      //   break;
      // case 'MANAGER':
      //   defaultPermissions = managerPermissionsData?.data?.permissions || [];
      //   break;
      // case 'CUSTOM':
      //   defaultPermissions = [];
      //   break;
    //   default:
    //     break;
    // }

    defaultPermissions = rolePermissionsData?.data?.permissions || []
    const permissions = defaultPermissions.map((p) => p._id);
    dispatch(setSelectedFeatures({ signal: true }));

    if (modulesData) {
      let updatedModules = JSON.parse(JSON.stringify(modulesData.data));
      updatedModules.forEach((module) => {
        module.features.forEach((feat) => {
          feat.checked = permissions.includes(feat.permission);
          if (permissions.includes(feat.permission)) {
            dispatch(setSelectedFeatures({ module: module.name, featId: feat.permission, type: 'add' }));
          }
        });
      });
      dispatch(setModules(updatedModules));
    }
  }, [
    role,
    modulesData,
    rolePermissionsData?.data,
    // candidatePermissionsData,
    // hrPermissionsData,
    // rmgPermissionsData,
    // managerPermissionsData,
    dispatch,
  ]);

  const handleGrantPermission = () => {
    grantPermission({
      users: selectedUsers.map((u) => u?.empCode),
      permissions: selectedPermissions,
    });
    dispatch(setGrantButtonDisabled(true))
  };
  const handleRevokePermission = () => {
    revokePermission({
      users: selectedUsers.map((u) => u?.empCode),
    });
    dispatch(setRevokeButtonDisabled(true))
  };

  const handleChange = (event, newValue) => {
    setModule(newValue);
  };

  const handleSettingsClicked = () => {
    setSettingsOpen(true);
  };
  const handleBack = () => {
    setSettingsOpen(false);
  };

  const handleDepartmentChange = (event) => {
    setSelectedDepartment(event.target.value);
    setSelectedRoleCategory('');
    setRole('');
  };

  const handleRoleCategoryChange = (event) => {
    setSelectedRoleCategory(event.target.value);
    setRole('');
  };

  const handleRolesChange = (event) => {
    setRole(event.target.value);
  };

  const departmentOptions = Roles.map((d) => d.department);

  const roleCategoryOptions = Roles.find((d) => d.department === selectedDepartment)?.roles || {};

  const roleOptions = roleCategoryOptions[selectedRoleCategory] || [];

  return settingsOpen ? (
    <>
      <Stack sx={{ height: 'calc(100vh - 125px)' }} spacing={0}>
        <Stack direction="row" alignItems="center" spacing={2} sx={{ p: 1 }}>
          <SupervisedUserCircle fontSize="large" />
          <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
            Permission Manager
          </Typography>
        </Stack>
        <SettingsHeader role={role} onBack={handleBack} />
        <SettingsTab empCode={role} />
      </Stack>
    </>
  ) : selectedUsers?.length > 0 ? (
    <Stack sx={{ p: 1, border: 0, height: 'calc(100vh - 125px)' }} spacing={1}>
      <Stack direction="row" alignItems="center" spacing={2}>
        <SupervisedUserCircle fontSize="large" />
        <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
          Permission Manager
        </Typography>
      </Stack>
      {/* <Stack direction="row" sx={{ mb: 2, border: 0 }} alignItems="center">
        <Typography>Select a role to apply default permissions:</Typography>
        <TextField select value={role} onChange={handleRoleChange} size="small" sx={{ width: '200px', ml: 2 }}>
          {roles.map((option, index) => (
            <MenuItem key={index} value={option}>
              {option}
            </MenuItem>
          ))}
        </TextField>
        <IconButton sx={{ color: 'black' }} onClick={handleSettingsClicked}>
          <Settings />
        </IconButton>
      </Stack> */}
      {/* modules */}
      <TabContext value={module}>
        <Stack direction="row" sx={{ border: 0,height:'75%' }}>
          <Box sx={{ height: 'calc(100vh - 330px)', border: 0, flex: 0.25 }}>
            <Typography sx={{ mb: 1 }}>Select a module</Typography>
            <TabList
              sx={{ height: '100%' }}
              onChange={handleChange}
              orientation="vertical"
              variant={'scrollable'}
              scrollButtons={'auto'}
              allowScrollButtonsMobile
            >
              {Object.keys(modules)?.map((mod, index) => {
                return <Tab key={index} label={mod} value={String(index + 1)} sx={{ alignItems: 'flex-start' }} />;
              })}
            </TabList>
          </Box>

          {/* tab panels for each module */}
          {Object.keys(modules)?.map((mod, index) => {
            return <FeaturePanel module={mod} key={index} value={String(index + 1)} features={modules[mod]} />;
          })}
        </Stack>
      </TabContext>
      <Stack direction={'row'} alignItems={'flex-end'} sx={{ border: 0, mt: '-40px', height: '15vh' }}>
        {selectedUsers.length > 0 && (
          <FormControl
            component="fieldset"
            sx={{
              borderRadius: variants.boxRadius.MAIN,
              border: 1,
              borderColor: 'divider',
              mx: 1,
              height: '100%',
              overflowY: 'auto',
            }}
          >
            <FormLabel component="legend">
              <Typography sx={{ fontSize: variants.BODY }}>User group</Typography>
            </FormLabel>
            <Box>
              {selectedUsers?.map((user, index) => {
                return (
                  <Chip
                    key={index}
                    avatar={<UserAvatar src={user?.employeePhotoPath} />}
                    label={user?.userName}
                    sx={{ m: 0.75 }}
                  />
                );
              })}
            </Box>
          </FormControl>
        )}
        <Stack sx={{ ml: 'auto' }} spacing={1}>
          <Tooltip placement="top-start" title="This will revoke all the permissions of selected user(s).">
            <Button
              size="small"
              variant="outlined"
              sx={{
                ml: 'auto',
                minWidth: '205px',

                '&:hover': { borderColor: 'error.dark', color: 'error.light' },
              }}
              disabled={grantDisabled || revokeButtonDisabled}
              startIcon={<RemoveCircleOutline />}
              onClick={handleRevokePermission}
            >
              Revoke permissions
            </Button>
          </Tooltip>
          <Button
            size="small"
            variant="contained"
            sx={{
              ml: 'auto',
              minWidth: '205px',
              alignItems: 'center',
              justifyContent: 'start',
              // backgroundColor: 'success.main',
              // '&:hover': { backgroundColor: 'success.dark' },
            }}
            disabled={grantDisabled || grantButtonDisabled}
            startIcon={<CheckCircleOutline sx={{ marginLeft: '5px' }} />}
            onClick={handleGrantPermission}
          >
            Grant permissions
          </Button>
        </Stack>
      </Stack>
    </Stack>
  ) : (
    <>
      <Box display={'flex'} flexDirection={'column'} justifyContent={'center'} width={'100%'} alignItems={'center'}>
        <Stack
          direction="column"
          sx={{ mt: 1, border: 0 }}
          alignItems="center"
          justifyContent={'center'}
          flex={4}
          width={'100%'}
          gap={1}
        >
          <Typography sx={{ fontSize: 18}}>Select Users to give permissions</Typography>
          {/* <Typography>Select a role to apply default permissions:</Typography> */}
          {/* <TextField select value={role} onChange={handleRoleChange} size="small" sx={{ width: '200px', ml: 2 }}>
            {roles.map((option, index) => (
              <MenuItem key={index} value={option}>
                {option}
              </MenuItem>
            ))}
          </TextField> */}
          {/* <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}> */}
            {/* Department Dropdown */}
            {/* <TextField
              select
              label="Department"
              value={selectedDepartment}
              onChange={handleDepartmentChange}
              size="small"
              sx={{ width: '220px' }}
            >
              {departmentOptions.map((dept, index) => (
                <MenuItem key={index} value={dept}>
                  {dept}
                </MenuItem>
              ))}
            </TextField> */}

            {/* Role Category Dropdown */}
            {/* <TextField
              select
              label="Role Category"
              value={selectedRoleCategory}
              onChange={handleRoleCategoryChange}
              size="small"
              sx={{ width: '220px' }}
              disabled={!selectedDepartment}
            >
              {Object.keys(roleCategoryOptions).map((category, index) => (
                <MenuItem key={index} value={category}>
                  {category}
                </MenuItem>
              ))}
            </TextField> */}

            {/* Role Dropdown */}
            {/* <TextField
              select
              label="Role"
              value={role}
              onChange={handleRolesChange}
              size="small"
              sx={{ width: '220px' }}
              disabled={!selectedRoleCategory}
            >
              {roleOptions.map((role, index) => (
                <MenuItem key={index} value={role}>
                  {role}
                </MenuItem>
              ))}
            </TextField> */}
          {/* </Box> */}
          {/* <IconButton sx={{ color: 'black' }} onClick={handleSettingsClicked}>
          <Settings />
        </IconButton> */}
          {/* <Button variant="outlined" onClick={handleSettingsClicked} disabled={role === ''}>
            Give Permission
          </Button> */}
        </Stack>
        <Box display={'flex'} justifyContent={'center'} alignItems={'center'} flex={8} width={'100%'}>
          <img src={Admin} alt="admin" height={'100%'} width={'100%'} />
        </Box>
      </Box>
    </>
  );
};

export default PermissionManager;
